import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthCard } from '@/pages/auth/AuthCard';
import { useRequestPasswordResetMutation } from '@/services/api';
import { isValidEmail } from '@/utils/auth';

export function ForgotPasswordPage(): JSX.Element {
  const [requestReset, { isLoading }] = useRequestPasswordResetMutation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const canSubmit = isValidEmail(email) && !isLoading;

  async function onSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    try {
      await requestReset({ email: email.trim() }).unwrap();
    } catch {
    }
    setSent(true);
  }

  if (sent) {
    return (
      <AuthCard>
        <h1 className="title">Check your inbox</h1>
        <div className="confirm-card" role="status">
          If an account exists for that email, a password reset link has been sent — check your inbox.
        </div>
        <p className="subtitle" style={{ marginBottom: 0 }}>
          The link is valid for 1 hour and can only be used once. If you don&apos;t see the email, check your
          spam folder.
        </p>
        <p className="auth-foot">
          <Link to="/login">Back to sign in</Link>
        </p>
      </AuthCard>
    );
  }

  return (
    <AuthCard>
      <h1 className="title">Reset your password</h1>
      <p className="subtitle">Enter the email tied to your account.</p>
      <form onSubmit={onSubmit} noValidate>
        <div className="field">
          <label className="field-label" htmlFor="fp-email">
            Email
          </label>
          <input
            id="fp-email"
            className="input"
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button className="btn-primary" type="submit" disabled={!canSubmit}>
          {isLoading ? 'Sending…' : 'Send reset link'}
        </button>
      </form>
      <p className="auth-foot">
        <Link to="/login">← Back to sign in</Link>
      </p>
    </AuthCard>
  );
}
